import { take } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';
import { getMenuListState, State } from '../redux/reducers';
import { MenuItem } from '../components/homepage/homepage-layout/menu-item.model';

@Injectable()
export class AccessGuard implements CanActivate {
  private readonly menuCodes$: Observable<any[]>;

  constructor(private readonly store: Store<State>, private readonly router: Router) {
    this.menuCodes$ = this.store.pipe(
      select(getMenuListState),
      map(menu => menu.menuList.navigation),
      filter(Boolean),
      map(this.getAllCodes)
    );
  }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    return this.menuCodes$.pipe(
      take(1),
      map(menuCodes => {
        if (this.allowed(menuCodes, route)) {
          return true;
        }
        console.warn('[ACCESS GUARD]');
        const redirect = route.data.accessGuardRedirect;
        if (redirect && menuCodes.some(code => code === redirect)) {
          return this.router.createUrlTree([redirect]);
        }
        return this.router.createUrlTree(['403']);
      })
    );
  }

  private readonly mapCodes = ({ code, children }): string[] => [code, ...children.map(this.mapCodes)];

  private readonly getAllCodes = (items: MenuItem[]) => items.map(this.mapCodes).flat(Infinity);

  private allowed(menuCodes: string[], route: ActivatedRouteSnapshot) {
    const path = route.pathFromRoot
      .map(snapshot => snapshot.url.map(url => url.path).join('/'))
      .filter(Boolean)
      .join('/');
    return menuCodes.some(code => code === path) || route.data.accessGuardCode === path;
  }
}
